import 'autotrack/lib/plugins/url-change-tracker';

let _d = undefined;
const sub = window.PubSub.subscribe;

let fbPixels = [];
let gaIds = [];
let _ = undefined;
let fetch = undefined;

sub('utilities.init', (msg, data)=>{
  _ = data.utils._;
  _d = data.utils.debug;
  fetch = data.utils.fetch;
  _d(msg, data);
});

sub('utilities.load_analytics.fb', (msg, data)=>{
  
  !(function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
  document,'script','https://connect.facebook.net/en_US/fbevents.js'));
  fbPixels.forEach((pixel) => {
    fbq('init', pixel.id);
  });
  _d(msg, data, fbPixels);
});

sub('utilities.pageview', (msg, data) => {
  
  let {only, except, params} = data.payload;
  pageView(only, except, params);
  _d(msg, data, only, except, params);
});

sub('utilities.fbViewContent', (msg, data) => {
  
  let {only, except, params} = data.payload;
  fbViewContent(only, except, params);
  gaAddImpression(only, except, params);
  _d(msg, data, only, except, params);
});

sub('utilities.gaExperiments', (msg, data) => {
  
  let {only, except, params} = data.payload;
  gaExperiments(only, except, params);
  _d(msg, data, only, except, params);
});

sub('utilities.load_analytics.ga', (msg, data)=>{
  data.payload = data.payload ? data.payload : {};
  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
  
  gaIds.forEach((pixel) => {

    const trackerName = gaNameResolver(pixel);

    ga('create', pixel.id, 'auto', trackerName, {allowLinker: true});
    ga(`${trackerName}.require`, 'ec');
    ga(`${trackerName}.require`, 'linker');
    ga(`${trackerName}.require`, 'urlChangeTracker');
    ga(`${trackerName}.linker:autoLink`, data.payload.autoLinkDomains || []);
  });

  ga((tracker)=>{
    istrack('utilities.GAloaded', {tracker})
  });
  
  _d(msg, data);
});

function gaNameResolver(pixel){
  let trackerName = 't0';
  let isDefault = pixel.isDefault ? pixel.isDefault : false;
  if(!isDefault){
    trackerName = pixel.name;
  }
  return trackerName;
}

sub('utilities.id.fb', (msg, data)=>{
  
  let {name, id} = data.payload;
  if(!_.some(fbPixels, {id}))
  {
    fbPixels.push({name, id});
  }
  _d(msg, data, fbPixels, name, id);
});

sub('utilities.id.ga', (msg, data)=>{
  let { name, id, isDefault } = data.payload;
  
  if(!_.some(gaIds, {id}))
  {
    gaIds.push({ name, id, isDefault });
  };
  _d(msg, data, gaIds);
});

sub('utilities.add_to_cart', (msg, data) =>{
  
  addToCart(...data.payload);
  _d(msg, data, 'DATA PAYLOAD SHOULD BE:', "[{ price, quantity, revenue, currency, fbqTrackData, gaECTrackData, gaEventTrackData }, only=[], except=[]]");
});

sub('utilities.checkout', (msg, data) =>{
  
  checkout(...data.payload);
  _d(msg, data, 'DATA PAYLOAD SHOULD BE:', "[{ price, quantity, revenue, currency, fbqTrackData, gaECTrackData, gaEventTrackData }, only=[], except=[]]");
});

sub('utilities.purchase', (msg, data) =>{
  
  purchase(...data.payload);
  _d(msg, data, 'DATA PAYLOAD SHOULD BE:', "[{ price, quantity, revenue, currency, fbqTrackData, gaECTrackData, gaEventTrackData }, only=[], except=[]]");
});

sub('utilities.custom_event', (msg, data) => {
  _d(msg, data, 'DATA PAYLOAD SHOULD BE:', ' { gaEventTrackData, fbqTrackData, except, only } ');

  let { gaEventTrackData, fbqTrackData, fbqTrackCustomName, except, only } = data.payload;

  fbPixels.forEach((tracker) =>{
    if(filterHandler(only, except, tracker)){
      fbq('trackSingleCustom',tracker.id, fbqTrackCustomName, { ...fbqTrackData, time: (new Date()) });
    }
  });

  gaCustomEvent(only, except, gaEventTrackData);
});

sub('utilities.screenview', (msg, data) => {
  _d(msg, data, 'DATA PAYLOAD SHOULD BE:', '  { gaEventTrackData, except, only } ');

  let { gaEventTrackData, except, only } = data.payload;

  gaIds.forEach((tracker) =>{
    if(filterHandler(only, except, tracker)){
      const trackerName = gaNameResolver(tracker);
      ga(`${trackerName}.send`, 'screenview', { ...gaEventTrackData });
    }
  });
});

sub('utilities.setDimension', (msg, data) => {
  _d(msg, data, 'DATA PAYLOAD SHOULD BE:', '  { gaEventTrackData, except, only } ');

  let { gaEventTrackData, except, only } = data.payload;

  gaIds.forEach((tracker) =>{
    if(filterHandler(only, except, tracker)){
      const trackerName = gaNameResolver(tracker);
      ga(`${trackerName}.set`, gaEventTrackData.dimension, gaEventTrackData.value);
    }
  });
});

sub('utilities.hotjar', (msg, data) => {
  (function(h,o,t,j,a,r){
    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
    h._hjSettings={hjid:data.payload.id,hjsv:6};
    a=o.getElementsByTagName('head')[0];
    r=o.createElement('script');r.async=1;
    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
    a.appendChild(r);
  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
});

sub('utilities.injectPixelIframe', (msg, data) => {
  _d(msg, data);
  injectPixelIframe(data.payload.url, data.payload.params)
});

sub('utilities.injectPixelImage', (msg, data) => {
  _d(msg, data);
  injectPixelImage(data.payload.url, data.payload.params)
});

sub('utilities.injectGoogleTagManager', (msg, data) => {
  _d(msg, data);
  injectGoogleTagManager(data.payload.gtm);
});

sub('utilities.injectGTM', (msg, data) => {
  _d(msg, data);
  injectGTM(data.payload.gtm);
});

sub('utilities.manageActiveCampaignTags', (msg, data) => {
  _d(msg, data);
  manageActiveCampaignTags(data.payload.url, data.payload.data);
});

sub('utilities.trackLead', (msg, data) => {
  _d(msg, data);
  let {only, except, params} = data.payload;
  fbTrackLead(only, except, params);
  gaCustomEvent(only, except, params);
});

function gaCustomEvent(only, except, gaEventTrackData) {
  gaIds.forEach((tracker) => {
    if (filterHandler(only, except, tracker)) {
      const trackerName = gaNameResolver(tracker);
      ga(`${trackerName}.send`, 'event', { ...gaEventTrackData });
    }
  });
}

function addToCart({ price, quantity, revenue, currency, fbqTrackData, gaECTrackData, gaEventTrackData }, only=[], except=[]) {
  fbPixels.forEach((tracker) =>{
    if(filterHandler(only, except, tracker)){
      fbq('trackSingle',tracker.id, 'AddToCart', { ...fbqTrackData, price, 'num_items': quantity, currency, value: price, time: (new Date()) });
    }
  });
  gaIds.forEach((tracker) =>{
    if(filterHandler(only, except, tracker)){
      const trackerName = gaNameResolver(tracker);
      ga(`${trackerName}.ec:addProduct`, { ...gaECTrackData, price, quantity });
      ga(`${trackerName}.ec:setAction`, 'add', { ...gaECTrackData, price, quantity, revenue, currency });
      ga(`${trackerName}.set`, 'currencyCode', currency);
      ga(`${trackerName}.send`, 'event', { ...gaEventTrackData });
    }
  });
}

function checkout({ price, quantity, revenue, currency, fbqTrackData, gaECTrackData, gaEventTrackData }, only=[], except=[]) {
  fbPixels.forEach((tracker) =>{
    if(filterHandler(only, except, tracker)){
      fbq('trackSingle',tracker.id, 'InitiateCheckout', { ...fbqTrackData, price, 'num_items': quantity, currency, value: revenue, time: (new Date()) });
    }
  });
  gaIds.forEach((tracker) =>{
    if(filterHandler(only, except, tracker)){
      const trackerName = gaNameResolver(tracker);
      ga(`${trackerName}.ec:addProduct`, { ...gaECTrackData, price, quantity });
      ga(`${trackerName}.ec:setAction`, 'checkout', { ...gaECTrackData, price, quantity, revenue, currency });
      ga(`${trackerName}.set`, 'currencyCode', currency);
      ga(`${trackerName}.send`, 'event', { ...gaEventTrackData });
    }
  });
}

function purchase({ price, quantity, revenue, currency,  fbqTrackData, gaECTrackData, gaEventTrackData }, only=[], except=[]) {
  fbPixels.forEach((tracker) =>{
    if(filterHandler(only, except, tracker)){
      fbq('trackSingle',tracker.id, 'Purchase', { ...fbqTrackData, price, 'num_items': quantity, currency, value: revenue, time: (new Date()) });
    }
  });
  gaIds.forEach((tracker) =>{
    if(filterHandler(only, except, tracker)){
      const trackerName = gaNameResolver(tracker);
      ga(`${trackerName}.ec:addProduct`, { ...gaECTrackData, price, quantity });
      ga(`${trackerName}.ec:setAction`, 'purchase', { ...gaECTrackData, price, quantity, revenue, currency });
      ga(`${trackerName}.set`, 'currencyCode', currency);
      ga(`${trackerName}.send`, {hitType: 'event', ...gaEventTrackData });
    }
  });
}

function getCookieBotConsentStatistics() {
  if (_.get(window, 'Cookiebot.hasResponse', false)) {
    return _.get(window, 'Cookiebot.consent.statistics', true);
  }
  return true;
}

function ga(...params) {
  if (window.ga && getCookieBotConsentStatistics()) { window.ga(...params); }
}

function fbq(...params) {
  if (window.fbq && getCookieBotConsentStatistics()) { window.fbq(...params); }
}

function gtag(...params){
  if (window.gtag && getCookieBotConsentStatistics()) { window.gtag(...params); }
}

function pageView(only=[], except=[], params= {fb:{}, ga:{}}){
  fbPixels.forEach((pixel) =>{
    if(filterHandler(only, except, pixel)){
      fbq('trackSingle', pixel.id, 'PageView', params.fb);
    }
  });

  gaIds.forEach((pixel) =>{
    if(filterHandler(only, except, pixel)){
      const trackerName = gaNameResolver(pixel);
      ga(`${trackerName}.send`, 'pageview');    
    }
  });
}

function gaExperiments(only=[], except=[], params){
  _d('gaExperiments', only, params)
  gaIds.forEach((pixel) => {
    if(filterHandler(only, except, pixel)){
      
      const trackerName = gaNameResolver(pixel);
      if(params.expId){
        ga(`${trackerName}.set`, 'expId', params.expId);
        ga(`${trackerName}.set`, 'expVar', params.expVar);
      }
    }
  });
}

function fbViewContent(only=[], except=[], params={}){
  fbPixels.forEach((pixel) =>{
    if(filterHandler(only, except, pixel)){
      fbq('trackSingle', pixel.id, 'ViewContent', params);
    }
  });
}

function fbTrackLead(only=[], except=[], params={}){
  fbPixels.forEach((pixel) =>{
    if(filterHandler(only, except, pixel)){
      fbq('trackSingle', pixel.id, 'Lead', params);
    }
  });
}

function gaAddImpression(only = [], except = [], params = {}){

  const p = {
    'brand': params.category,
    'category': params.category,
    'name': params.name,
    'id': params.id,
    'label': params.id,
    'variant': params.variant,
  }
  gaIds.forEach((tracker) =>{
    if(filterHandler(only, except, tracker)){
      const trackerName = gaNameResolver(tracker);
      ga(`${trackerName}.ec:addImpression`, params);
    }
  });
}

function filterHandler(only = [], except = [], tracker){
  if(only.length){
    return only.includes(tracker.name);
  }
  return !except.includes(tracker.name);
}

function injectPixelIframe(url, params){
  _d('inject iframe', url, params);
  Object.keys(params).forEach(p => {
    url = url.replace(`{{${p}}}`, params[p])
  })

  //scrolling="no" frameborder="0" width="1" height="1"
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.attributes.scrolling = 'no';
  iframe.attributes.frameborder= 0;
  iframe.attributes.width = 1;
  iframe.attributes.height = 1;
  iframe.src = url;
  document.body.appendChild(iframe);
}

function injectPixelImage(url, params){
  _d('inject iframe', url, params);
  Object.keys(params).forEach(p => {
    url = url.replace(`{{${p}}}`, params[p])
  })

  //scrolling="no" frameborder="0" width="1" height="1"
  const iframe = document.createElement('img');
  iframe.style.display = 'none';
  iframe.attributes.scrolling = 'no';
  iframe.attributes.frameborder= 0;
  iframe.attributes.width = 1;
  iframe.attributes.height = 1;
  iframe.src = url;
  document.body.appendChild(iframe);
}

function injectGoogleTagManager(gtm){
  
  if(!getCookieBotConsentStatistics()){
    return;
  }

  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + gtm;
  script.async = true;
  script.type = 'text/javascript';

  document.getElementsByTagName('head')[0].appendChild(script);

  window.dataLayer = window.dataLayer || []; 
  window.gtag = window.gtag || function gtag(){dataLayer.push(arguments);} 
  window.gtag('js', new Date()); gtag('config', gtm);
}

function injectGTM(gtm){
  if(!getCookieBotConsentStatistics()){
    return;
  }

  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', gtm);
}

function manageActiveCampaignTags(url, data) {
  const payload = data;
  fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(function (response) {
      return response.json()
    }).then(function (json) {
      _d('parsed json', json)
    }).catch(function (ex) {
      _d('parsing failed', ex)
    })
}